"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultEnquireState = exports.defaultEnquireForm = void 0;
var LoginState_1 = require("@/pages/common/states/LoginState");
var ResultPageState_init_1 = require("@/pages/search/states/ResultPageState.init");
var SavedResultItem_init_1 = require("@/pages/search/states/SavedResultItem.init");
var ReplyBar_init_1 = require("@/pages/common/states/ReplyBar.init");
exports.defaultEnquireForm = {
    firstname: '',
    lastname: '',
    fullname: '',
    salutation: LoginState_1.Salutation.NONE,
    email: '',
    phone: '',
    budget: '',
    comment: '',
    update: true,
};
exports.defaultEnquireState = {
    isDim: false,
    isActive: false,
    isLoading: false,
    current: null,
    currentEnquireName: 'hi',
    favorites: [SavedResultItem_init_1.defaultSavedResultItem1, SavedResultItem_init_1.defaultSavedResultItem2],
    favoritesInt: [SavedResultItem_init_1.defaultSavedResultItem2, SavedResultItem_init_1.defaultSavedResultItem1],
    enquiry: exports.defaultEnquireForm,
    t: {
        nameContactAgent: 'Contact Agent',
        nameContactCaption: 'Find your perfect home',
        nameEnquiring: 'Enquiring',
        nameFavorite: 'Local Favorite',
        nameFavoriteInt: 'Internactional Favorite',
        nameUnavailable: 'Unavailable',
        // tslint:disable-next-line:max-line-length
        namePrivacyPolicy: 'All personal information will remain strictly confidential and will be used only for communication purposes as outlined in our <a class="o-textbtn" target="_blank" href="/en/general/privacypolicy">Privacy Policy</a>',
        nameSubjectToOffer: 'Subject To Offer',
        nameSa: '/SQFT(SA)',
        nameGfa: '/SQFT(GFA)',
        nameCall: 'Call',
        namePerMo: '',
        nameInquiryFor: 'Inquiry for:',
        whatsappTemplate: 'I\'m interested in %s - ref# %s. %s',
        whatsappTemplatePlace: 'I\'m interested in %s - %s',
        whatsappTemplateSimple: 'ref# %s',
    },
    tForm: {
        email: 'Email',
        required: 'Required',
        nameSubmit: 'Contact',
        emailFormat: 'Invalid Email Format',
        phoneFormat: 'Invalid Phone Format',
        emailRequired: 'Email Required',
        firstnameRequired: 'Firstname Required',
        fullnameRequired: 'Name Required',
        lastnameRequired: 'Lastname Required',
        phoneRequired: 'Phone Required',
        phoneOremailRequired: 'Phone or Email Required',
        placeholderEmail: 'Email',
        placeholderFirstName: 'First Name',
        placeholderFullName: 'Name',
        placeholderLastName: 'Last Name',
        placeholderPhone: 'Phone',
        placeholderBudget: 'Budget',
        placeholderComment: 'Tell us about what your are looking for ...',
        placeholderUpdate: 'Receive property updates',
        header: 'Please tell us how you would like to be contacted',
    },
    salutations: [
        [1, 'Mr'],
        [2, 'Mrs'],
        [3, 'Ms'],
    ],
    tResult: ResultPageState_init_1.defaultResultPageState.t,
    replybar: ReplyBar_init_1.defaultReplyBar,
    errors: {
        email: '',
        name: '',
        phone: '',
        comment: '',
    },
    required: {
        email: true,
        name: true,
        phone: true,
        comment: false
    },
    disabled: {
        email: false,
        name: false,
        phone: false,
        comment: false,
        submit: false,
        subscribe: false,
    },
    lastEnquiry: null
};
